import { EntityRepository } from '@record-it-npm/synchro-client';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';
import { AppEntityManagerEntityTypesByEntityName } from '../AppEntityManagerEntityTypesByEntityName';
import { UserGroupToUser } from './userGroupToUserTypes';
export class UserGroupToUserRepository extends EntityRepository<AppSynchronizationEnvironmentTypes, EntityName.UserGroupToUser, AppEntityManagerEntityTypesByEntityName> {
  public getByUserId(userId: string): Array<UserGroupToUser> {
    return this.getAll().filter(r => r.userId === userId);
  }
  public getByUserGroupId(userGroupId: string): Array<UserGroupToUser> {
    return this.getAll().filter(r => r.ownerUserGroupId === userGroupId);
  }
}